import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/lifetimeValueByMembershipsSagas";

export const UpdateBtns = ({ params }) => {
  const dispatch = useDispatch();
  const { filtersDirty } = useSelector((state) => state.lifetimeValueByMembership);

  return filtersDirty ? (
    <div className="action-buttons">
      <button className="submit" onClick={() => dispatch(actionCreators.updateChart())}>
        Update
      </button>
      <button
        className="submit reset"
        onClick={() => dispatch(actionCreators.fetchCurrentUser(params))}
      >
        Reset
      </button>
    </div>
  ) : null;
};
